// needed because Safari refuses to support Custom built-in elements
import '@ungap/custom-elements';
